'use strict';

bbw.directive.bbwHref = ['BBW_APP', 'bbw.RedirectSvc', function(BBW_APP, redirectSvc) {
    return {
        restrict: 'A',
        link: {
            pre: function(scope, element, attrs) {
                if (attrs.target) {
                    return;
                }
                var linkSpec = (attrs.bbwHref || '').split(':');
                if (linkSpec.length < 2) {
                    throw new Error("Invalid bbw-href: " + attrs.bbwHref);
                }
                var targetApp = linkSpec.shift();
                var targetHref = linkSpec.join(':');
                var canUseXhr = true;

                element.attr('href', targetHref);
                if (targetApp !== '*' && BBW_APP !== targetApp) {
                    element.attr('target', '_self');
                    canUseXhr = false;
                }

                if (attrs.redirect) {
                    redirectSvc.redirect({url: targetHref, timeout: attrs.redirect, xhr: canUseXhr});
                }
            }
        }
    };
}];
